export const locales = {
  fr: import('dayjs/locale/fr'),
  en: import('dayjs/locale/en'),
  it: import('dayjs/locale/it'),
  // cimode is used for tests to return the key instead of the translation
  cimode: import('dayjs/locale/en'),
}
